import moment from 'moment';
import urlConfig from 'Url';
import Routes from 'Routes';
import { submitPay, createWechatSdk, encrypt } from 'Utils';
import { getChangeDetail } from '../routes/reformProcess/modules/actions';
import { isCsairApp, getCookieUserInfo } from '@csair/emp-helpers';

export const CHANGE_NAVBAR_STATE = 'CHANGE_NAVBAR_STATE';
export const SAVE_OLD_LOCATION = 'SAVE_OLD_LOCATION';
export const EDIT_LOGINPARAM_FEEQUERY = 'EDIT_LOGINPARAM_FEEQUERY';
export const GET_SYS_CONFIG = 'GET_SYS_CONFIG';
export const GO_CHANGE_PAY = 'GO_CHANGE_PAY';
export const CANCLE_CHANGE_PAY = 'CANCLE_CHANGE_PAY';
export const CHECK_LUCK_DRAW_ENTRY = 'CHECK_LUCK_DRAW_ENTRY';
export const PAY_MILEAGE = 'PAY_MILEAGE';
export const VERIFY_MILEAGE = 'VERIFY_MILEAGE';
export const GET_COUNTRY_DATA = 'GET_COUNTRY_DATA';
export const GET_APP_CONFIG = 'GET_APP_CONFIG';
export const SET_PSGS_FLIGHTS = 'SET_PSGS_FLIGHTS';
export const GET_USER_INFO = 'GET_USER_INFO';
export const READ_COOIKE_USERINFO = 'READ_COOIKE_USERINFO';
export const GET_CITY_WIDGET = 'GET_CITY_WIDGET';
export const GET_PASSAGEMEMBER_LEVEL = 'GET_PASSAGEMEMBER_LEVEL';
export const CREATE_NPSQNR_DETAIL = 'CREATE_NPSQNR_DETAIL';
export const CREATE_FDB_URL = 'CREATE_FDB_URL';
export const GET_MILEAGE_SWITCH = 'GET_MILEAGE_SWITCH';
export const GET_MENU_LIST = 'GET_MENU_LIST';
export const GET_AD_INFO = 'GET_AD_INFO';
export const GET_AD_SWITCH = 'GET_AD_SWITCH';
export const GET_ALL_SWITCH = 'GET_ALL_SWITCH';

export const GET_MOREQUERY_SWITCH = 'GET_MOREQUERY_SWITCH';
export const GET_LANGUAGE = 'GET_LANGUAGE';

export function getLanguage(lang) {
  return { type: GET_LANGUAGE, lang };
}
// 临时勾选状态存储操作
export function setSimpleStatus(psgs, flights) {
  return { type: SET_PSGS_FLIGHTS, psgs, flights };
}

// 修改状态栏状态
export function changeNavbarState(state) {
  return { type: CHANGE_NAVBAR_STATE, state };
}

// 保存旧的历史地址
export function saveOldLocation(data) {
  return { type: SAVE_OLD_LOCATION, data };
}

// 修改退改费用url带参数查询状态
export function editLoginParamFeeQuery() {
  return { type: EDIT_LOGINPARAM_FEEQUERY };
}

/**
 * @description 获取用户基本信息
 */
export function getUserInfo() {
  return (dispatch, getState) => {
    const {
      App: { userInfo },
    } = getState();
    if (!userInfo.channel)
      dispatch({
        type: GET_USER_INFO,
        closeLoading: true,
        payload: {
          request: {
            url: urlConfig.getUserInfo,
            method: 'post',
            data: {},
          },
        },
      });
  };
}

// 获取配置
export function getSysConf() {
  return {
    type: GET_SYS_CONFIG,
    closeLoading: true,
    payload: {
      request: {
        url: urlConfig.getConfig,
        method: 'post',
        data: {
          key: [
            'is_Easy_Login_Turn_On',
            'is_authenticate_turn_on',
            'is_recommend_turn_on',
            'has_luck_draw_movable_switch_bool',
            'the_flag_fastchange',
          ],
        },
      },
    },
  };
}

/**
 * @description 获取前端程序配置
 */
export function getAppConf() {
  return {
    type: GET_APP_CONFIG,
    closeLoading: true,
    payload: {
      request: {
        url: urlConfig.app_config_url,
        method: 'get',
        params: {
          t: new Date().getTime(),
        },
      },
    },
  };
}

/**
 * @description 获取支付参数
 */
export function volunteerChangePay(data) {
  return {
    type: GO_CHANGE_PAY,
    payload: {
      request: {
        url: urlConfig.volunteerChangePay,
        method: 'post',
        data,
        headers: {
          'x-requested-with': 'XMLHttpRequest',
          'login-channel': navigator.userAgent
            .toLowerCase()
            .includes('toutiaomicroapp')
            ? 'd'
            : 'm',
          'client-device': isCsairApp() ? 'app' : 'touch',
        },
      },
    },
  };
}

/**
 * @description 变更支付
 * @param {string} changeNo 变更单号
 * @param {func} fail 报错回调函数
 */
export function h5_pay(
  changeNo,
  fail,
  load,
  totalPayMoney,
  bigOrderNo,
  ismu,
  payXSOOrderUppReq
) {
  return async (dispatch, getState) => {
    let isAIComming = window.sessionStorage.getItem('isAIComming');
    let isAICommingFT = window.sessionStorage.getItem('isAICommingFT');
    let orderingSite = window.sessionStorage.getItem('orderingSiteCode');
    let urlAppos = window.location.href.indexOf('appos') !== -1;
    let url =
      urlConfig.payCallBackUrl +
      '?' +
      (isAIComming || isAICommingFT ? 'channel=AI&' : '') +
      (isAIComming ? 'from=assistant&' : '');
    if (
      window.location.href.indexOf(Routes.ticket.child.applySubmit.path) !== -1
    ) {
      url += 'vipMember=Y&';
    }
    if (payXSOOrderUppReq) {
      url = urlConfig.pageInfoDto.homeUrl + '?';
    }
    let obj = JSON.parse(JSON.stringify(urlConfig.pageInfoDto));
    if (isAICommingFT || isCsairApp()) {
      obj.titleShow = 'N';
    }
    let DYurl = '';
    if (navigator.userAgent.toLowerCase().includes('toutiaomicroapp')) {
      DYurl = `${
        process.env.REACT_APP_APP
      }ticketRefund/#/ticket/ReformProcess?orderNo=${
        changeNo.indexOf('ES') !== -1 && bigOrderNo ? bigOrderNo : changeNo
      }&orderType=S&channel=DY`;
      obj.orderChangeDetailUrl = DYurl;
    }
    const {
      payload: {
        data: {
          errorInfo,
          token,
          merAppId,
          merId,
          version,
          language,
          callBackSuccessDto,
        },
      },
    } = await dispatch(
      volunteerChangePay({
        changeNo,
        callBackUrl: encodeURIComponent(url),
        pageInfoDto: obj,
        ...(bigOrderNo ? { changeUppReq: { orderId: bigOrderNo } } : {}),
        ...(isCsairApp() && window.CSNativeObject.getOSType() === 'harmony'
          ? // || /Harmony/i.test(navigator.userAgent)
            { hmChannel: 'hm' }
          : {}),
        ...(navigator.userAgent.toLowerCase().includes('toutiaomicroapp')
          ? { dyChannel: 'DY' }
          : {}),
        orderChannel: isCsairApp() ? 'App' : 'Mobile',
        ...(ismu ? { isCeAirline: '1' } : {}), //东航标识
        ...(payXSOOrderUppReq ? { payXSOOrderUppReq: payXSOOrderUppReq } : {}),
        ...(orderingSite === 'appos' || urlAppos
          ? { orderingSite: 'appos' }
          : {}),
        wxChannel:
          window.__wxjs_environment &&
          window.__wxjs_environment === 'miniprogram'
            ? '1'
            : '0',
      })
    );
    if (errorInfo) {
      fail(errorInfo);
      return false;
    }
    if (callBackSuccessDto) {
      window.location.href = `${
        process.env.REACT_APP_APP
      }ticketRefund/#/ticket/ReformProcess?orderNo=${
        changeNo.indexOf('ES') !== -1 && bigOrderNo ? bigOrderNo : changeNo
      }&orderType=S`;
      return false;
    }
    let isEN = window.sessionStorage.getItem('language') == 'en';
    submitPay({
      token,
      merAppId,
      merId,
      version,
      DYurl,
      ...(isEN ? { language: 'en_US' } : { language }),
    });
  };
}

/**
 * @description 获取小程序增值开关配置
 */
export function getExtraConfig() {
  return {
    type: 'GET_EXTRA_CONFIG',
    closeLoading: true,
    payload: {
      request: {
        url: urlConfig.commonSystemSwitch,
        method: 'post',
        data: {
          switchKey: 'EXTRA_EMP_APPLET_CASHIER',
        },
      },
    },
  };
}

/**
 * @description 微信小程序支付
 * @param {string} changeNo
 * @param {func} fail 报错回调函数
 * @param {bool} load 获取详情单是否开启load加载框， 默认false
 */
export function wechat_pay(changeNo, fail, cost, load = false, bigOrderNo) {
  return async (dispatch, getState) => {
    const {
      payload: { data },
    } = await dispatch(
      getChangeDetail(
        {
          changeNo: bigOrderNo ? bigOrderNo : changeNo,
        },
        load
      )
    );

    if (data.errorInfo) {
      fail(data.errorInfo);
      return false;
    }

    if (wx && wx.miniProgram) {
      // const time =
      //   moment(data.progressBar.dealtime)
      //     .add(40, 'minutes')
      //     .unix() - moment().unix();
      // if (time < 0) {
      //   alert('支付超时');
      //   return false;
      // }
      const time = data.progressBar.payDiffTime;
      if (data.progressBar.paymentTimeout) {
        alert('支付超时');
        return false;
      }
      const { insuranceDetailList = [], changePrice = {}, base = {} } = data;
      const insuranceMoney =
        insuranceDetailList.reduce((sum, cur) => sum + cur.orderPrice, 0) || 0;
      const payMoney = changePrice.totalPayMoney + insuranceMoney;
      const url = encodeURIComponent(
        `${urlConfig.payCallBackUrl}?orderNo=${
          bigOrderNo ? bigOrderNo : data.changeNo
        }&payMoney=${payMoney}`
      );

      //小程序端，订单中包含保险，且支付金额不为0, 调增值的收银台
      if (insuranceDetailList.length && payMoney > 0) {
        const { payload = {} } = await dispatch(getExtraConfig());
        if (
          payload.data &&
          payload.data.isOpen &&
          payload.data.isOpen === 'Y'
        ) {
          const orderType =
            data.changeNo.includes('S') || data.changeNo.includes('GO')
              ? 'S'
              : 'T';
          const cancelPayUrl = encodeURIComponent(
            `${
              process.env.REACT_APP_APP
            }ticketRefund/#/ticket/ReformProcess?orderNo=${
              bigOrderNo ? bigOrderNo : data.changeNo
            }&orderType=${orderType}&channel=wxopen`
          );
          wx.miniProgram.navigateTo({
            url: `/page/jump?action=extraPayPage&globalNo=${
              base.globalNo
            }&payCallbackUrl=${url}&isUseTooken=Y&buyerId=${
              base.submitUserId
            }&cancelPayUrl=${cancelPayUrl}`,
          });
          return false;
        }
      }

      wx.miniProgram.navigateTo({
        url: `/page/jump?action=unifiedPay&external=refund&orderNo=${
          bigOrderNo ? bigOrderNo : data.changeNo
        }&amount=${data.changePrice.totalPayMoney.toFixed(
          1
        )}&countdown=${time}&successPage=${url}&changeType=${
          data.base.changeType === 'E' ? 'e2e' : 's'
        }`,
      });
    } else {
      alert('支付异常');
    }
  };
}

/**
 * @description 统一支付，区分渠道调用不同支付方式
 */
export function unitePay(...params) {
  return (dispatch, getState) => {
    // if (
    //   window.__wxjs_environment &&
    //   window.__wxjs_environment === 'miniprogram' &&
    //   !params[6] &&
    //   !params[7]
    // ) {
    //   !wx && createWechatSdk();
    //   dispatch(wechat_pay(...params));
    // } else {
      dispatch(h5_pay(...params));
    // }
  };
}

/**
 * @description 取消变更单
 */
export function cancleChangePay(data) {
  return {
    type: CANCLE_CHANGE_PAY,
    payload: {
      request: {
        url: urlConfig.cancleChangePayIn,
        method: 'post',
        data,
      },
    },
  };
}

/**
 * @description 取消OO变更单
 */
export function cancleChangeOOPay(data) {
  return {
    type: CANCLE_CHANGE_PAY,
    payload: {
      request: {
        url: urlConfig.cancleChangeOOPayIn,
        method: 'post',
        data,
      },
    },
  };
}

// 检验抽奖器入口
export function checkLuckDrawEntry(order, bool = false) {
  return {
    type: CHECK_LUCK_DRAW_ENTRY,
    closeLoading: bool,
    payload: {
      request: {
        url: urlConfig.checkLuckDrawEntry + '?' + new Date().getTime(),
        method: 'post',
        data: order,
      },
    },
  };
}

// 支付里程
export function payMileage(data) {
  return {
    type: PAY_MILEAGE,
    payload: {
      request: {
        url: urlConfig.exchangePayMileage,
        method: 'post',
        data,
      },
    },
  };
}
// 里程验证
export function verifyMileage(data) {
  return {
    type: VERIFY_MILEAGE,
    payload: {
      request: {
        url: urlConfig.checkSvcFfpMemberPwd,
        method: 'post',
        data,
      },
    },
  };
}

// 验证支付里程
export function mileageProcess(changeNo, success, fail, isGo, goFail) {
  return async (dispatch, getState) => {
    const {
      payload: {
        data: { payPassWord, result },
      },
    } = await dispatch(
      verifyMileage({
        passWord: encrypt(document.getElementById('mileage-pwd').value),
        changeNo,
      })
    );
    if (payPassWord !== 'Y') {
      if (payPassWord === 'N') {
        if (result.indexOf('N/24小时内剩余错误次数') !== -1)
          fail('密码错误，请重新输入');
        if (result.indexOf('N/验密错误次数超过限制') !== -1)
          fail('您的账号已经被锁定，请稍后重新输入');
      } else {
        fail('密码错误，请重新输入');
      }
      return false;
    }

    if (isGo) {
      // await dispatch(unitePay(changeNo, goFail, true));
      await dispatch(
        unitePay(changeNo, goFail, false, '', '', false, false, true)
      );
    } else {
      const {
        payload: {
          data: { responseCode, responseMessage, errorCode, message },
        },
      } = await dispatch(
        payMileage({
          changeNo,
        })
      );
      if (errorCode || responseCode !== '00') {
        fail(responseMessage || message);
        return false;
      }
      if (responseCode === '00') {
        success();
      }
    }
  };
}

export function getCountryData() {
  return {
    type: GET_COUNTRY_DATA,
    payload: {
      request: {
        url: '/public/country.json',
        method: 'get',
      },
    },
  };
}

export function readCookieSetUserInfo() {
  return {
    type: READ_COOIKE_USERINFO,
    data: getCookieUserInfo(),
  };
}

export function getPassageMemberLevel(data) {
  return {
    type: GET_PASSAGEMEMBER_LEVEL,
    payload: {
      request: {
        url: urlConfig.getPassageMemberLevel,
        method: 'post',
        data,
      },
    },
  };
}

export function createNpsQnrDetail(data) {
  return {
    type: CREATE_NPSQNR_DETAIL,
    payload: {
      request: {
        url: urlConfig.createNpsQnrDetail,
        method: 'post',
        data,
      },
    },
  };
}

export function searchNpsUrl(data) {
  return {
    type: CREATE_FDB_URL,
    closeLoading: true,
    payload: {
      request: {
        url: urlConfig.searchNpsUrl,
        method: 'post',
        data,
      },
    },
  };
}

/**
 * @description 获取里程字段开关
 */
export function getMileageSwitch() {
  return {
    type: GET_MILEAGE_SWITCH,
    payload: {
      request: {
        url: urlConfig.memberSystemSwitch,
        method: 'post',
        data: {
          switchKey: 'EXTRA_EMP_SWITHC_INTEGRAL',
        },
      },
    },
  };
}

/**
 * @description 获取服务列表开关
 */
export function getMenuList() {
  return {
    type: GET_MENU_LIST,
    payload: {
      request: {
        url: urlConfig.getMenuList,
        method: 'post',
        data: {},
      },
    },
  };
}

export function getAdInfo(data) {
  return {
    type: GET_AD_INFO,
    payload: {
      request: {
        url: urlConfig.getAdInfo,
        method: 'post',
        data,
      },
    },
  };
}

/**
 * @description 获取广告字段开关
 */
export function getAdSwitch() {
  return {
    type: GET_AD_SWITCH,
    payload: {
      request: {
        url: urlConfig.memberSystemSwitch,
        method: 'post',
        data: {
          switchKey: 'CHANGE_ADVERTISEMENT_SWITCH',
        },
      },
    },
  };
}
export function getMoreQuerySwitch(val) {
  return {
    type: GET_MOREQUERY_SWITCH,
    payload: {
      request: {
        url: urlConfig.memberSystemSwitch,
        method: 'post',
        data: {
          switchKey: val,
        },
      },
    },
  };
}
export function getAllSwitch(val) {
  return {
    type: GET_ALL_SWITCH,
    payload: {
      request: {
        url: urlConfig.memberAllSwitch,
        method: 'post',
        data: {
          switchKeys: val,
        },
      },
    },
  };
}

export function getcustomerUrlSwitch() {
  return {
    type: GET_ALL_SWITCH,
    payload: {
      request: {
        url: urlConfig.customerUrlSwitchOn,
        method: 'post',
        data: {},
      },
    },
  };
}



// WEBPACK FOOTER //
// ./src/routes/modules/actions.js